import { ClientGroup } from '../../../interfaces';
import Statements from '../../client/components/statements';

const CorporationStatements = ({ clientGroup }: { clientGroup: ClientGroup }) => (
  <Statements clientGroupIds={[clientGroup.id]} showClients />
);

export default CorporationStatements;
